import { Plus } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgAdd = mkIcon(Plus);